import * as _ from 'lodash';
import * as angular from 'angular';

import BaseResource from '../models/base-resource';
import JsonApiResource from '../models/jsonapi-resource';
import JsonApiParser from './jsonapi-parser';

interface BuildFunction<T> {
  (): T;
}
abstract class ResourceService<T extends BaseResource> {
  type: string;
  backendService: any;
  defaultFilter: object = {};

  constructor(BackendService, private resourceType: { new (): T }) {
    this.backendService = BackendService;
    const resource = new resourceType();
    this.type = resource.type;
  }

  get = (id, query) => {
    let resource;
    if (id === 'new') {
      resource = this.build();
    } else {
      resource = this.backendService.get(this.type, id, query);
    }
    return resource;
  };

  getAll = (query = {}) => {
    _.merge(query, this.defaultFilter);
    return this.backendService.getAll(this.type, query);
  };

  save = (resource: T) => {
    let result;
    const packed: JsonApiResource = resource.pack();

    if (packed.id) {
      result = this.backendService.update(this.type, packed);
    } else {
      result = this.backendService.create(this.type, packed);
    }

    return result;
  };

  delete = (resource: T) => this.backendService.delete(this.type, resource);

  // This produces a "blank" version of the resource, useful for setting defaults
  build: BuildFunction<T> = () => new this.resourceType();
}

export default ResourceService;



// WEBPACK FOOTER //
// ./common/services/resource.service.ts